import {
  Center,
  Flex,
  Group,
  Loader,
  Modal,
  Stack,
  Text,
  useMantineTheme,
  Button,
  Box,
  Select,
  Image,
  List,
  Divider,
  Input,
  Tabs,
  ScrollArea,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import {
  IconMessageCircle,
  IconPhoto,
  IconSearch,
  IconSettings,
  IconX,
} from "@tabler/icons";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { User1 } from "../../@types/User";
import { MySimulations } from "../../components/Simulations/MySimulations";
import {
  SimulationCard,
  Simulations,
} from "../../components/Simulations/Simulations";
import {
  getSimulationById,
  getUserSimulations,
} from "../../features/Simulations/getSimulationSlice";
import { AppDispatch, RootState } from "../../store/ReduxStore";
import { isPremiumModalOpened } from "../../store/premiumModalSlice";
import { ParentPageEvents } from "../../utilities/Mixpanel/AnalyticEventParentApp";
import { WebAppEvents } from "../../utilities/Mixpanel/AnalyticeEventWebApp";
import { Mixpanel } from "../../utilities/Mixpanel/MixpanelHelper";
import { SimulationsLoaderMiddleware } from "../../components/Simulations/SimulationsLoaderMiddleware";
const isPremiumModalOpenedActions = isPremiumModalOpened.actions;
export enum SimulationTypeEnum {
  UNITY,
  THREEJS,
  MODELJSON,
  REACTIONJSON,
}
let k = false;

export function checkIfPacakgeIsAvailable(sim: SimulationData | null) {
  if (sim === null) return false;
  return (
    sim.downloadPackages?.windows?.length > 0 ||
    sim.downloadPackages?.mac?.length > 0 ||
    sim.downloadPackages?.linux?.length > 0 ||
    sim.downloadPackages?.android?.length > 0
  );
}
export function Allsimulations() {
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [isComplete, setisComplete] = useState<boolean>(false);
  const [activeSimulationTab, setActiveSimulationTab] =
    useState<string>("simulations");
  const [simualtionId, setSimualtionId] = useState<string>("");
  const [simulation, setSimulation] = useState<SimulationData | null>(null);
  const theme = useMantineTheme();
  const isMd = useMediaQuery(`(max-width: ${theme.breakpoints.md}px)`);
  const navigate = useNavigate();
  const [playSimulation, setPlaySimulation] = useState<{
    name: string;
    _id: string;
  } | null>(null);
  const [mySimulationId, setMysimualtionId] = useState<string | null>(null);
  const [modalSimulation, setModalSimulation] = useState<{
    name: string;
    _id: string;
    isSimulationPremium: boolean;
    videoUrl: string;
    isthreejs: boolean;
  } | null>(null);
  const [videoLoaded, setVideoLoaded] = useState(false);

  const userSubjects = useSelector<RootState, UserClassAndSubjects[]>(
    (state) => {
      return state.subjectSlice.userSubjects;
    }
  );

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const paramValue = queryParams.get("type");

  useEffect(() => {
    if (paramValue && paramValue === "parent") {
      Mixpanel.track(ParentPageEvents.PARENT_APP_SIMULATION_LIST_PAGE_ACCESSED);
    } else
      Mixpanel.track(WebAppEvents.TEACHER_APP_SIMULATION_LIST_PAGE_ACCESSED);
  }, []);

  function handleVideoLoaded() {
    setVideoLoaded(true);
  }

  const getSimulation = async () => {
    if (modalSimulation !== null) {
      const response = await getSimulationById({ id: modalSimulation._id });
      const simulations = response as SimulationData;
      setSimulation(simulations);
    }
  };

  useEffect(() => {
    getSimulation();
  }, [modalSimulation]);

  const [mySimulations, setMySimulations] = useState<any>([]);

  function getUserMySimulations() {
    getUserSimulations()
      .then((x: any) => {
        const mySimulations = x
          .filter((s: any) => s.simulationId != null)
          .map((s: any) => s.simulationId);
        setMySimulations(mySimulations);
      })
      .catch((e) => {
        console.log(e);
      });
  }
  useEffect(() => {
    getUserMySimulations();
  }, []);

  const videoRef = useRef(null);
  const user = useSelector<RootState, User1 | null>((state) => {
    return state.currentUser.user;
  });
  const [isFilterClicked, setFilterClicked] = useState<boolean>(false);

  const dispatch = useDispatch<AppDispatch>();
  const [mobileSearchClicked, setMobileSearchClicked] =
    useState<boolean>(false);
  const inputRef = useRef<any>(null);
  useEffect(() => {
    if (inputRef && inputRef.current && inputRef.current.focus)
      inputRef.current.focus();
  }, [mobileSearchClicked]);

  const [selectSimulationCategory, setSelectSimulationCategory] =
    useState<string>("0");

  const [scrollY, setScrollY] = useState<number>(0);

  const [reachedBottom, setReachedBottom] = useState<{ state: boolean }>({
    state: false,
  });

  const handleScrollPositionChange = (position: any) => {
    if (!scrollAreaRef.current) return;
    const scrollElement = scrollAreaRef.current;

    if (position.y < scrollY) {
      setScrollY(position.y);
      return;
    }
    setScrollY(position.y);
    // Calculate the total scrollable height and the visible height
    const totalScrollHeight = scrollElement.scrollHeight - 70;
    setReachedBottom({ state: position.y >= totalScrollHeight / 2 });
  };

  const scrollAreaRef = useRef<HTMLDivElement>(null);
  return (
    <ScrollArea
      h={"100vh"}
      ref={scrollAreaRef}
      onScrollPositionChange={handleScrollPositionChange}
    >
      <Stack w="99%" h="99%">
        {!isFilterClicked && (
          <Stack
            spacing={0}
            w={"auto"}
            style={{
              position: "sticky",
              top: 0,
              right: 0,
              zIndex: 11,
              background: "white",
              borderBottom: "1px solid #EDF0FE",
            }}
          >
            <Flex
              justify="space-between"
              align="center"
              px={isMd ? 5 : 27}
              py={15}
              sx={{
                background: isMd
                  ? "white"
                  : "linear-gradient(180deg, #FFFFFF 0%, #F3F5FD 100%)",
              }}
            >
              <Flex
                align={isMd ? "start" : "center"}
                w={"100%"}
                justify={"space-between"}
              >
                <Text
                  style={{
                    fontWeight: 700,
                    fontSize: "28px",
                    fontFamily: "Nunito",
                  }}
                  ml={isMd ? 2 : 10}
                >
                  Simulations
                </Text>
                {/* {!isMd && (
                  <Select
                    mr={"2rem"}
                    value={selectSimulationCategory}
                    onChange={(value: string) =>
                      setSelectSimulationCategory(value)
                    }
                    data={[
                      { value: "0", label: "All" },
                      { value: "1", label: "Simulations" },
                      { value: "2", label: "Models" },
                      { value: "3", label: "Animations" },
                    ]}
                    radius={10}
                    rightSection={""}
                    sx={{
                      select: {
                        border: "2px solid #808080 ",
                        borderRadius: "1rem",
                      },
                    }}
                  />
                )} */}
              </Flex>
              <Group
                sx={{
                  textAlign: "left",
                  borderRadius: 10,
                }}
              >
                {
                  <>
                    {isMd && (
                      <>
                        {!mobileSearchClicked && (
                          <IconSearch
                            size={30}
                            color="#525e7e"
                            onClick={() => {
                              setMobileSearchClicked(true);
                            }}
                          />
                        )}

                        {mobileSearchClicked && (
                          <Box
                            style={{
                              border: "1px solid #525E7E",
                              width: "150px",
                              height: "40px",
                              borderRadius: "20px",
                              padding: "1px",
                              paddingLeft: "12px",
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <IconSearch size={25} color="#525e7e" />

                            <Input
                              placeholder="Search"
                              value={searchQuery}
                              styles={{
                                input: {
                                  fontFamily: "Nunito",
                                  width: "90%",
                                  border: "none",
                                  fontSize: "15px",
                                  padding: "5px",
                                  outline: "none",
                                  marginRight: "3px",
                                  backgroundColor:
                                    "linear-gradient(180deg, #FFFFFF 0%, #F3F5FD 100%)",
                                },
                              }}
                              ref={inputRef}
                              onChange={(e) => {
                                setSearchQuery(e.target.value);
                                if (paramValue && paramValue === "parent") {
                                  Mixpanel.track(
                                    ParentPageEvents.PARENT_APP_SIMULATION_PAGE_SEARCH_TYPED
                                  );
                                } else {
                                  Mixpanel.track(
                                    WebAppEvents.TEACHER_APP_SIMULATION_PAGE_SEARCH_TYPED,
                                    {
                                      query: e.target.value,
                                    }
                                  );
                                }
                              }}
                            />
                            <IconX
                              onClick={() => {
                                setMobileSearchClicked(false);
                                setSearchQuery("");
                              }}
                              style={{
                                marginRight: "3px",
                              }}
                              size={30}
                            />
                          </Box>
                        )}
                      </>
                    )}
                    {!isMd && (
                      <Box
                        style={{
                          border: "1px solid #525E7E",
                          width: "307px",
                          height: "40px",
                          borderRadius: "20px",
                          padding: "1px",
                          paddingLeft: "12px",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <IconSearch size={25} color="#525e7e" />

                        <Input
                          placeholder="Search for Simulation"
                          value={searchQuery}
                          styles={{
                            input: {
                              fontFamily: "Nunito",
                              background: "#F7F9FE",
                              width: "90%",
                              fontSize: "15px",
                              padding: "5px",
                              marginRight: "3px",
                              border: "none",
                              borderRadius: "4px",
                              outline: "none",
                            },
                          }}
                          onChange={(e) => {
                            setSearchQuery(e.target.value);
                            if (paramValue && paramValue === "parent") {
                              Mixpanel.track(
                                ParentPageEvents.PARENT_APP_SIMULATION_PAGE_SEARCH_TYPED
                              );
                            } else {
                              Mixpanel.track(
                                WebAppEvents.TEACHER_APP_SIMULATION_PAGE_SEARCH_TYPED,
                                {
                                  query: e.target.value,
                                }
                              );
                            }
                          }}
                        />
                      </Box>
                    )}
                  </>
                }
              </Group>
            </Flex>
            {/* Simulation Category UI will replace once simualtions are enough */}
            {/* <Flex
              pr={10}
              display={isMd ? "block" : "hidden"}
              align={"center"}
              justify={"end"}
            >
              {isMd && (
                <Select
                  value={selectSimulationCategory}
                  onChange={(value: string) =>
                    setSelectSimulationCategory(value)
                  }
                  my={8}
                  w={"9rem"}
                  ml={"auto"}
                  rightSection={""}
                  data={[
                    { value: "0", label: "All" },
                    { value: "1", label: "Simulations" },
                    { value: "2", label: "3D Models" },
                    { value: "3", label: "3D Animation" },
                  ]}
                  radius={"xl"}
                  sx={{
                    select: {
                      border: "2px solid #808080 ",
                      borderRadius: "1rem",
                    },
                  }}
                />
              )}
            </Flex> */}
          </Stack>
        )}
        <Tabs
          defaultValue="simulations"
          w="100%"
          mx="auto"
          styles={{
            tab: {
              fontSize: isMd ? 14 : 16,
              padding: isMd ? "8px 12px" : "10px 20px",
            },
          }}
          color="#3374f9"
        >
          <Tabs.List
            sx={{
              display: "flex",
              flexWrap: "nowrap",
              justifyContent: isMd ? "center" : "start",
              gap: isMd ? "8px" : "20px",
            }}
          >
            <Tabs.Tab
              fz={isMd ? 14 : 16}
              w={"auto"}
              color="#4b65f6"
              fw={activeSimulationTab === "simulations" ? 700 : 500}
              sx={{
                color:
                  activeSimulationTab === "simulations" ? "#111" : "#bbbbbb",
                borderBottom:
                  activeSimulationTab === "simulations"
                    ? "3px solid blue"
                    : "2px solid transparent",
                textAlign: "center",
              }}
              onClick={() => setActiveSimulationTab("simulations")}
              value="simulations"
              icon={
                <Box
                  sx={{
                    background:
                      activeSimulationTab === "simulations"
                        ? "#DBE0FF"
                        : "rgba(234, 235, 213, 0.3)",
                    width: isMd ? 30 : 40,
                    height: isMd ? 30 : 40,
                    borderRadius: "50%",
                    marginRight: isMd ? 5 : 10,
                  }}
                />
              }
            >
              All Simulations
            </Tabs.Tab>
            <Tabs.Tab
              fw={activeSimulationTab === "mySimulations" ? 700 : 500}
              fz={isMd ? 14 : 16}
              color="#4b65f6"
              sx={{
                color:
                  activeSimulationTab === "mySimulations" ? "#111" : "#bbbbbb",
                borderBottom:
                  activeSimulationTab === "mySimulations"
                    ? "3px solid blue"
                    : "2px solid transparent",
                textAlign: "center",
              }}
              onClick={() => setActiveSimulationTab("mySimulations")}
              value="mySimulations"
              icon={
                <Box
                  sx={{
                    background:
                      activeSimulationTab === "mySimulations"
                        ? "#DBE0FF"
                        : "rgba(234, 235, 213, 0.3)",
                    width: isMd ? 30 : 40,
                    height: isMd ? 30 : 40,
                    borderRadius: "50%",
                    marginRight: isMd ? 5 : 10,
                  }}
                />
              }
            >
              My Simulations
            </Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="simulations" pt="xs">
            <Simulations
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              isComplete={isComplete}
              setisComplete={setisComplete}
              paramValue={paramValue}
              setModalSimulation={setModalSimulation}
              setPlaySimulation={setPlaySimulation}
              setSimualtionId={setSimualtionId}
              setSimulation={setSimulation}
              setVideoLoaded={setVideoLoaded}
              isFilterClicked={isFilterClicked}
              setMysimualtionId={setMysimualtionId}
              userSubjects={userSubjects}
              selectSimulationCategory={Number(selectSimulationCategory)}
              reachedBottom={reachedBottom}
              setReachedBottom={setReachedBottom}
            />
          </Tabs.Panel>

          <Tabs.Panel value="mySimulations" pt="xs">
            <Flex w={"95%"} h={"100%"} mx={"auto"} wrap={"wrap"}>
              {mySimulations && mySimulations.length > 0 ? (
                mySimulations.map((x: any) => (
                  <>
                    <Box w={"350px"} h={"300px"}>
                      <SimulationCard
                        _id={x._id}
                        name={x.name}
                        isthreejs={x.isthreejs}
                        lgNo={4}
                        imageUrl={x.thumbnailImageUrl}
                        simulationType={x.simulationType}
                        setSimualtionId={(val) => {
                          setSimualtionId(val);
                        }}
                        setPlaySimulation={(id) => {
                          setMysimualtionId(null);
                          setPlaySimulation(x);
                          setModalSimulation(null);
                          setVideoLoaded(false);
                        }}
                        simulationTags={x.simulationTags}
                        paramValue={paramValue}
                        userSubscriptionType={
                          paramValue === "parent"
                            ? "PREMIUM"
                            : user?.subscriptionModelType ?? ""
                        }
                        isSimulationPremium={x.isSimulationPremium}
                        setModalSimulation={(x) => {
                          setSimulation(null);
                        }}
                        videoUrl={x.videoUrl}
                        showInfo={true}
                        simulation={x}
                      />
                    </Box>
                  </>
                ))
              ) : (
                <Stack w={"100%"} h={"70vh"} align="center" justify="center">
                  <Image
                    src={require("../../assets/emptySimulations.png")}
                    m={"auto"}
                    width={"200px"}
                  />
                </Stack>
              )}
            </Flex>
          </Tabs.Panel>
        </Tabs>
      </Stack>
      {playSimulation && (
        <SimulationsLoaderMiddleware simulationId={playSimulation!!._id}  onSimulationClosed={()=>{
          setPlaySimulation(null)
        }}/>
      )}
      <Modal
        opened={modalSimulation !== null}
        onClose={() => {
          setVideoLoaded(false);
          setModalSimulation(null);
        }}
        centered
        size={"lg"}
        padding={0}
        radius={0}
        withCloseButton={true}
        mt={"sm"}
        style={{ zIndex: 2000 }}
      >
        {modalSimulation !== null && (
          <>
            <Box>
              {!simulation?.thumbnailImageUrl ? (
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    paddingTop: "20px",
                  }}
                >
                  <Loader color="blue" size="md" />
                </Box>
              ) : (
                <Box>
                  <video
                    controls
                    src={modalSimulation.videoUrl}
                    onLoadedData={handleVideoLoaded}
                    ref={videoRef}
                    autoPlay
                    loop
                    muted
                    className="video-no-controls"
                    style={{
                      width: `${isMd ? "100%" : "100%"}`,
                      display: videoLoaded ? "block" : "none",
                    }}
                    playsInline
                    preload="auto"
                  />
                  {(!videoLoaded || !modalSimulation.videoUrl) && (
                    <Image
                      alt="Tech"
                      style={{
                        width: "100%",
                        marginTop: "-50px",
                      }}
                      src={simulation?.thumbnailImageUrl}
                    />
                  )}
                  <Button
                    style={{
                      position: "absolute",
                      top: "-40px",
                      right: "10px",
                      border: "none",
                      outline: "none",
                      cursor: "pointer",
                      display: "flex",
                      padding: "3px",
                      transitionDelay: "300ms",
                      borderRadius: "50%",
                      justifyContent: "center",
                      alignItems: "center",
                      background: "#313131",
                    }}
                    onClick={() => {
                      setVideoLoaded(false);
                      setModalSimulation(null);
                    }}
                  >
                    <IconX color="white" />
                  </Button>
                </Box>
              )}
              {simulation?.thumbnailImageUrl ? (
                <Button
                  className="modalPlay"
                  style={{
                    border: "none",
                    outline: "none",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "10px",
                    paddingRight: "25px",
                    paddingLeft: "25px",
                    position: "absolute",
                    borderRadius: "2px",
                    bottom: "20px",
                    cursor: "pointer",
                    left: "20px",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (user?.subscriptionModelType === "FREE") {
                      if (
                        modalSimulation &&
                        (modalSimulation.isSimulationPremium === undefined ||
                          modalSimulation?.isSimulationPremium)
                      ) {
                        Mixpanel.track(
                          WebAppEvents.VIGNAM_APP_PREMIUM_FEATURE_ACCESSED,
                          {
                            feature_name: "premium_simulation_accessed",
                            current_page: "all_simulations_page",
                          }
                        );
                        setVideoLoaded(false);
                        setModalSimulation(null);
                        dispatch(
                          isPremiumModalOpenedActions.setModalValue(true)
                        );
                      } else {
                        navigate(`/openSimulation/${simulation._id}`);
                      }
                    } else if (
                      user?.subscriptionModelType !== "FREE" ||
                      paramValue === "parent"
                    ) {
                      if (
                        modalSimulation &&
                        (modalSimulation.isSimulationPremium === undefined ||
                          modalSimulation.isSimulationPremium)
                      ) {
                        navigate(`/openSimulation/${simulation._id}`);
                      } else {
                        navigate(`/openSimulation/${simulation._id}`);
                      }
                    }
                  }}
                >
                  <Image
                    src={require("../../assets/playBtn.png")}
                    alt="Play"
                    style={{ width: "21px", height: "21px" }}
                  />
                  <span style={{ marginLeft: "10px", color: "white" }}>
                    Play
                  </span>
                </Button>
              ) : (
                ""
              )}
            </Box>

            <Box
              style={{
                paddingLeft: "30px",
                paddingRight: "20px",
                fontFamily: "Nunito",
              }}
            >
              <Flex align={"center"} gap={20}>
                <Text style={{ fontWeight: "700", fontSize: "25px" }}>
                  {simulation?.name}
                </Text>
              </Flex>
              <Button
                className="modalPlay2"
                style={{
                  border: "none",
                  outline: "none",
                  width: "100%",
                  marginTop: "20px",

                  justifyContent: "center",
                  alignItems: "center",
                  padding: "10px",
                  paddingRight: "25px",
                  paddingLeft: "25px",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (user?.subscriptionModelType === "FREE") {
                    if (
                      modalSimulation.isSimulationPremium === undefined ||
                      modalSimulation.isSimulationPremium
                    ) {
                      Mixpanel.track(
                        WebAppEvents.VIGNAM_APP_PREMIUM_FEATURE_ACCESSED,
                        {
                          feature_name: "premium_simulation_accessed",
                          current_page: "all_simulations_page",
                        }
                      );
                      setVideoLoaded(false);
                      setModalSimulation(null);
                      dispatch(isPremiumModalOpenedActions.setModalValue(true));
                    } else {
                      if (simulation) {
                        navigate(`/openSimulation/${simulation._id}`);
                      }
                    }
                  } else if (
                    user?.subscriptionModelType !== "FREE" ||
                    paramValue === "parent"
                  ) {
                    if (
                      modalSimulation.isSimulationPremium === undefined ||
                      modalSimulation.isSimulationPremium
                    ) {
                      if (simulation) {
                        navigate(`/openSimulation/${simulation._id}`);
                      }
                    } else {
                      if (simulation) {
                        navigate(`/openSimulation/${simulation._id}`);
                      }
                    }
                  }
                }}
              >
                <Image
                  src={require("../../assets/playBtn.png")}
                  alt="Play"
                  style={{ width: "21px", height: "21px" }}
                />
                <span style={{ marginLeft: "10px", color: "white" }}>Play</span>
              </Button>
              <Text>{simulation?.simulationDescription}</Text>
              {simulation?.simulationfeatures && (
                <>
                  <Text style={{ fontWeight: "700" }}>Key Features:</Text>
                  <List>
                    {simulation.simulationfeatures.map((feature) => (
                      <List.Item>{feature}</List.Item>
                    ))}
                  </List>
                </>
              )}
            </Box>
          </>
        )}
      </Modal>
    </ScrollArea>
  );
}
